import {
  FETCH_WATER_SYSTEMS_REQUEST,
  FETCH_WATER_SYSTEMS_SUCCESS,
  FETCH_WATER_SYSTEMS_FAILURE,
} from "../actions/waterSystems.actions";

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
};

const waterSystems = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WATER_SYSTEMS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_WATER_SYSTEMS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
      };
    case FETCH_WATER_SYSTEMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default waterSystems;
